import axios from 'axios'
import { tokenUrl, baseUrl } from '@/api/config'
import qs from 'qs'
export function getLogin(params) {
  const url = tokenUrl + '/oauth/token'
  return axios({
    headers: {
      Authorization: 'Basic Z2F0ZXdheToxMjM0NTY=',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'post',
    url: url,
    data: qs.stringify(params.data),
  })
    .then(res => {
      sessionStorage.setItem('roleIds', res.data.roleIds)
      sessionStorage.setItem('featureCode', res.data.featureCode)
      sessionStorage.setItem('isAdmin', res.data.isAdmin)
      sessionStorage.setItem('account', res.data.account)
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

/**
 *根据过期的access_token 获取新的access_token
 * */
export function refreshToken(params) {
  const url = tokenUrl + '/oauth/token'
  return axios({
    headers: {
      Authorization: 'Basic Z2F0ZXdheToxMjM0NTY=',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'post',
    url: url,
    data: qs.stringify(params),
  }).then(resDate => {
    sessionStorage.setItem('roleIds', resDate.data.roleIds)
    sessionStorage.setItem('featureCode', resDate.data.featureCode)
    sessionStorage.setItem('isAdmin', resDate.data.isAdmin)
    sessionStorage.setItem('account', resDate.data.account)
    return Promise.resolve(resDate.data)
  })
}

export function getLogout() {
  const url = '/auth/logout'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取验证码
export function getCodePic(params) {
  const url = tokenUrl + '/kaptcha/verification'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 发送短信验证码
export function smsSend(params) {
  const url = tokenUrl + '/sms/send'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 忘记密码电话重置
export function resetOauthPassword(params) {
  const url = tokenUrl + '/oauth/reset'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取租户直播、实时视频录制配置
export function getRecordFlag() {
  const url = baseUrl + '/tenant/transcribe/list'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取私有化配置数据
export function getIntranetData() {
  const url = tokenUrl + '/global/config'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
